import axios from 'axios';
import {urlBackend} from '../../main/Util'

export const apiFile = axios.create({
    baseURL:urlBackend,
    withCredentials: true,
    responseType: 'blob',  
});


class ReportFaturaService{

    constructor(){
        this.apiUrl = '/portal/fatura';
    }

    static registerSession(token){
        if(token){
            apiFile.defaults.headers.common['Authorization'] = `Bearer ${token}` 
            apiFile.defaults.headers.common['Cache-Control'] = `no-cache`        
        }
    }

    getFile(url, params){
        const requestUrl = `${this.apiUrl}${url}`
        return apiFile.post(requestUrl, params);
    }

}

export default ReportFaturaService;